var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { checkLogin } from '../../../common/decorators';
import './Setting.style.scss';
import Icon from '../components/Icon';
import RecChannel from '../common/rec/RecChannel';
let Setting = class Setting extends VueType {
    constructor() {
        super(...arguments);
        this.showToast = false;
    }
    logout() {
        this.showToast = true;
    }
    closeToast() {
        this.showToast = false;
    }
    created() {
    }
    render() {
        if (!txv.login.isLogin()) {
            const dom = <RecChannel title="您的在追片单暂无内容,不如试试这些专属推荐"></RecChannel>;
            return <div>
        {dom}
      </div>;
        }
        const label = <div class="logout">
                    <div class="logout-wrapper">
                      <div class="logout__title">账号注销</div>
                      <div class="logout__desc">账号注销相关的操作管理</div>
                    </div>
                    <div class="logout__btn" onClick={this.logout}>注销</div>
                  </div>;
        const toast = <div class="toast-tips" v-show={this.showToast}>
                    <div class="toast-tips__panel">
                      <div class="panel__header">
                        注销账号须知
                      </div>
                      <div class="panel__main">
                        <div class="panel__main-title">
                          亲爱的用户，您好，由于需要校验您的商城订单及游戏权益等信息，账号注销无法在电脑端完成，请前往腾讯视频手机端APP内确认操作
                        </div>
                        <div class="panel__main-content">
                          <img src="//vfiles.gtimg.cn/vupload/20211206/5c3b031638792984654.png" class="panel__main-content-qrcode"/>
                          <div class="panel__main-content-tips">
                            <p>操作路径：</p>
                            <p>腾讯视频APP-个人中心-设置-隐私设置</p>
                            <p>您也可以微信扫描左侧二维码后操作</p>
                            <p class="panel__main-content-warning">
                              <Icon w={16} h={16} xlink={'#svg_tips'} class="panel__main-content-icon"></Icon>
                              腾讯视频账号注销后，将不可恢复，请您谨慎操作
                            </p>
                          </div>
                        </div>
                        <div class="panel__main-btn" onClick={this.closeToast}>
                          我知道了
                        </div>
                      </div>
                      <Icon class="toast-close" w={16} h={16} xlink={'#svg_close'} nativeOnClick={this.closeToast}></Icon>
                    </div>
                  </div>;
        return <div>
      {label}
      {toast}
    </div>;
    }
};
__decorate([
    checkLogin
], Setting.prototype, "created", null);
Setting = __decorate([
    Component
], Setting);
export default Setting;
